import { NEXEN_BUCKET } from '../config/urls';
import LibraryItem from '../shared/interfaces/libraryItem.interface';

export default function getItemFileUrl(item: LibraryItem): string {
    return `${NEXEN_BUCKET}${item.file.awsFilePath}/${item.file.awsFileName}`;
}
